import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { environment } from '../../../environments/environment';
import { Utils } from '../../shared/helpers/utils';

import { ApiService } from '../../shared/services/api.service';
import { Product, ProductOrder, Poptional, Subpoptional, PoptionalSelection } from '../../shared/models';
import { faMinus, faPlus } from '../../icons';
@Component({
    selector: 'app-selected-product',
    templateUrl: './selected-product.component.html',
    styleUrls: ['./selected-product.component.scss'],
    standalone: false
})
export class SelectedProductComponent implements OnInit {
      faPlus = faPlus;
    faMinus = faMinus;
  @Input() product: Product;
  @Output() onClose: EventEmitter<string> = new EventEmitter();
  @Output() onAdd: EventEmitter<ProductOrder> = new EventEmitter();

  adding: boolean = false;
  poptionals: Poptional[] = [];
  poptionalsLoaded: boolean = false;
  poptionalsLoadFailed: boolean = false;

  item: ProductOrder = <ProductOrder>{
    quantity: 1,
    notes_obj: [{
      text: ''
    }],
    created_at: new Date().toISOString()
  };

  serverUrl: string = environment.server_url;

  constructor(private api: ApiService) { }

  ngOnInit(): void {
    this._loadPoptionals();
    this.item.product = this.product;
    this.item.product_id = this.product.id;
  }

  exit(method: 'button') {
    this.onClose.emit(method);
  }

  addProduct() {
    // Guard against the poptionals request still being in flight (or having
    // failed): without this, tapping ADICIONAR before it resolves would fall
    // through to the "no poptionals" branch below and add the item to the
    // cart without ever enforcing its required (non-hidden, min_qty > 0)
    // poptionals.
    if(!this.poptionalsLoaded) {
      if(this.poptionalsLoadFailed) {
        alert("Não foi possível carregar as opções deste produto. Tentando novamente...");
        this._loadPoptionals();
      }
      return;
    }

    if(this.poptionals.length > 0) {
      this.adding = true;
    } else {
      this.done();
    }
  }

  done(selectedPoptionals: PoptionalSelection[]|null = null) {
    let aux_item = Utils.clone(this.item);
    aux_item.poptional_selections = selectedPoptionals;
    ProductOrder.setAdditionalData(aux_item);
    this.send(aux_item);
  }
  send(auxItem: ProductOrder = null) {
    if(auxItem == null)
      auxItem  = Utils.clone(this.item);

    if(auxItem.notes_obj[0].text.length > 0) {
      auxItem.notes_attributes = auxItem.notes_obj;
    }
    delete auxItem.notes_obj;

    this.onAdd.emit(auxItem);
  }

  private _loadPoptionals() {
    this.poptionals = [];
    this.poptionalsLoaded = false;
    this.poptionalsLoadFailed = false;
    this.api.indexAll('poptionals', {
      q: {
        pcategory_id: this.product.pcategory_id,
        hidden: false
      }
    }).subscribe(
      res => {
        this.poptionals = Poptional.fromJsonArray(res.poptionals);
        this.poptionalsLoaded = true;
      },
      err => {
        console.log(err);
        this.poptionalsLoadFailed = true;
      }
    );
  }
}
